import { fetchOnboardingType } from './fetch-onboarding-type/index.tsx';

export const actions = {
	fetchOnboardingType,
} as const;

export type Actions = typeof actions;
